'use strict';

var react = require('react');
var reactHookForm = require('react-hook-form');
var yup = require('@hookform/resolvers/yup');
var Form = require('../Form/Form.js');

/**
 * Form hook.
 */ function useForm({ schema, showRequiredIndicators, showOptionalIndicators, raw, ...props }) {
    // Initialize react-hook-form
    const context = reactHookForm.useForm({
        // Default form options
        criteriaMode: 'all',
        mode: 'all',
        // Overwrite default options
        ...props,
        // Schema resolver
        resolver: yup.yupResolver(schema, {}, {
            rawValues: raw
        })
    });
    // Custom form options
    const options = react.useMemo(()=>({
            showRequiredIndicators,
            showOptionalIndicators
        }), [
        showRequiredIndicators,
        showOptionalIndicators
    ]);
    // Create abstracted form with context and options
    const Form$1 = react.useMemo(()=>Form.createForm(context, options), [
        context,
        options
    ]);
    // Return abstracted form and context
    return [
        Form$1,
        context
    ];
}

exports.useForm = useForm;
//# sourceMappingURL=useForm.js.map
